import { useParams } from 'react-router';

import Ocu3SsSingleSCMCard from '@/features/engineoil/card/customer/Ocu3SsSingleSCMCard';
import Ocu3SsSingleSCSCard from '@/features/engineoil/card/customer/Ocu3SsSingleSCSCard';
import Tbm3DidSCMCard from '@/features/engineoil/card/customer/Tbm3DidSCMCard';
import Tbm3DidSCSCard from '@/features/engineoil/card/customer/Tbm3DidSCSCard';
import Tbm3SsSeriesSCMCard from '@/features/engineoil/card/customer/Tbm3SsSeriesSCMCard';
import Tbm3SsSeriesSCSCard from '@/features/engineoil/card/customer/Tbm3SsSeriesSCSCard';
import Tbm3SsSingleSCMCard from '@/features/engineoil/card/customer/Tbm3SsSingleSCMCard';
import Tbm3SsSingleSCSCard from '@/features/engineoil/card/customer/Tbm3SsSingleSCSCard';
import { PRODUCT_LEVEL, SOURCE_DEVICE, SOURCE_TYPE } from '@/features/engineoil/utils/constants';
import { useGetEngineOilQuery } from '@/services/api';
import CardSkeletonScreen from './CardSkeletonScreen';
import Cm4SensorSignalSeriesSCMCard from './Cm4SensorSignalSeriesSCMCard';
import Cm4SensorSignalSeriesSCSCard from './Cm4SensorSignalSeriesSCSCard';
import NoDataCard from './NoDataCard';

const CustomerCard = () => {
    const { assetId } = useParams<{ assetId: string }>();

    const { data: engineOil, isLoading, error } = useGetEngineOilQuery(assetId!);

    const content = (() => {
        if (isLoading) {
            return <CardSkeletonScreen />;
        }

        if (error || !engineOil) {
            return <NoDataCard />;
        }

        switch (engineOil.source_device) {
            case SOURCE_DEVICE.CM4:
                switch (engineOil.source_type) {
                    case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                        switch (engineOil.booked_product) {
                            case PRODUCT_LEVEL.SERVICE_CARE_L:
                            case PRODUCT_LEVEL.SERVICE_CARE_M:
                                return <Cm4SensorSignalSeriesSCMCard engineOil={engineOil} />;
                            case PRODUCT_LEVEL.SERVICE_CARE_S:
                                return <Cm4SensorSignalSeriesSCSCard engineOil={engineOil} />;
                            default:
                                return null;
                        }
                    case SOURCE_TYPE.DID:
                        return null;
                    default:
                        return null;
                }
            case SOURCE_DEVICE.TBM3:
                switch (engineOil.source_type) {
                    case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                        switch (engineOil.booked_product) {
                            case PRODUCT_LEVEL.SERVICE_CARE_L:
                            case PRODUCT_LEVEL.SERVICE_CARE_M:
                                return <Tbm3SsSeriesSCMCard engineOil={engineOil} />;
                            case PRODUCT_LEVEL.SERVICE_CARE_S:
                                return <Tbm3SsSeriesSCSCard engineOil={engineOil} />;
                            default:
                                return null;
                        }
                    case SOURCE_TYPE.SENSOR_SIGNAL_SINGLE:
                        switch (engineOil.booked_product) {
                            case PRODUCT_LEVEL.SERVICE_CARE_L:
                            case PRODUCT_LEVEL.SERVICE_CARE_M:
                                return <Tbm3SsSingleSCMCard engineOil={engineOil} />;
                            case PRODUCT_LEVEL.SERVICE_CARE_S:
                                return <Tbm3SsSingleSCSCard engineOil={engineOil} />;
                            default:
                                return null;
                        }
                    case SOURCE_TYPE.DID:
                        switch (engineOil.booked_product) {
                            case PRODUCT_LEVEL.SERVICE_CARE_L:
                            case PRODUCT_LEVEL.SERVICE_CARE_M:
                                return <Tbm3DidSCMCard engineOil={engineOil} />;
                            case PRODUCT_LEVEL.SERVICE_CARE_S:
                                return <Tbm3DidSCSCard engineOil={engineOil} />;
                            default:
                                return null;
                        }
                    default:
                        return null;
                }
            case SOURCE_DEVICE.OCU3:
                switch (engineOil.source_type) {
                    case SOURCE_TYPE.SENSOR_SIGNAL_SINGLE:
                        switch (engineOil.booked_product) {
                            case PRODUCT_LEVEL.SERVICE_CARE_L:
                            case PRODUCT_LEVEL.SERVICE_CARE_M:
                                return <Ocu3SsSingleSCMCard engineOil={engineOil} />;
                            case PRODUCT_LEVEL.SERVICE_CARE_S:
                                return <Ocu3SsSingleSCSCard engineOil={engineOil} />;
                            default:
                                return null;
                        }
                    default:
                        return null;
                }
            default:
                return null;
        }
    })();

    return <div style={{ fontFamily: 'Source Sans Pro, Helvetica, Arial, sans-serif' }}>{content}</div>;
};

export default CustomerCard;
